
















































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData, Child } from "@/models/app-data";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { Child1Content } from "@/models/content/child-1";

@Component({
  components: {
    FooterButton,
  },
})
export default class Child1 extends Mixins(CommonMixin) {
  content: Child1Content = {} as Child1Content;
  appData = {} as AppData;
  PercentDone = 40;
  childNames: Array<string> = [];
  textDirection = "ltr";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getChild1Content();
      this.textDirection = contentService.TextDirection();

      this.appData = this.getAppData();
      this.childNames = new Array<string>(
        this.appData.numberOfChildrenApplying
      );
      this.putWorkflowStep( this.appData?.workflowId, "Child1") 
    } catch (error) {
      this.showError(error);
    }
  }

  disableNext(): boolean {
    const atLeastOneName = this.childNames.some(
      (name) => !!name && name.length > 0
    );
    return !atLeastOneName;
  }

  public handleNextPageEvent(): void {
    const names = this.childNames.filter((name) => !!name && name.length > 0);

    this.appData.children = new Array<Child>();
    names.forEach((name) => {
      const child = {} as Child;
      child.fullName = name;
      this.appData.children.push(child);
    });
    this.saveData();
    this.$router.push({ path: "Child2/0" });
  }

  saveData(): void {
    this.saveAppData(this.appData);
  }
}
